import React from 'react';
import { useTenant } from './useTenant';
import ContextualLoginPage from './ContextualLoginPage';
import { useGoogleOneTap } from './useGoogleOneTap';
import { useAuth } from './useAuth';

const LoginWithDashboardContext: React.FC = () => {
  const tenant = useTenant();
  const { refreshAuth } = useAuth();
  const displayName = tenant.name || 'Recruit41';

  // Google One Tap / FedCM auto sign-in for returning ATS users.
  // This component only renders when unauthenticated on the dashboard login,
  // so the "live session already exists" case (EC-4) is naturally skipped.
  useGoogleOneTap({ enabled: true, onSuccess: refreshAuth });

  return (
    <ContextualLoginPage
      contextDescription={`You're signing in to access the ${displayName} Employer Dashboard.`}
      isDashboardLogin={true}
    />
  );
};

export default LoginWithDashboardContext;
